import { render, staticRenderFns } from "./ClientWholesaleSetup.vue?vue&type=template&id=36a4e7ef&scoped=true&"
import script from "./ClientWholesaleSetup.vue?vue&type=script&lang=js&"
export * from "./ClientWholesaleSetup.vue?vue&type=script&lang=js&"
import style0 from "./ClientWholesaleSetup.vue?vue&type=style&index=0&id=36a4e7ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a4e7ef",
  null
  
)

export default component.exports